var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIssueReportBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0027 7.99925V5.82635C15.0027 5.29613 14.7916 4.78692 14.4164 4.41176L11.5872 1.58258C11.2121 1.20743 10.7029 0.996338 10.1726 0.996338H2.99766C1.8922 0.996338 0.996826 1.89171 0.996826 2.99717V17.003C0.996826 18.1085 1.8922 19.0038 2.99766 19.0038H6.99933",
    stroke: "#006487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0026 5.99842H11.0009C10.4487 5.99842 10.0005 5.55023 10.0005 4.998V0.996338",
    stroke: "#006487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5021 20.0042C11.0161 20.0042 9.00024 17.9884 9.00024 15.5024C9.00024 13.0163 11.0161 11.0005 13.5021 11.0005C15.9892 11.0005 18.004 13.0163 18.004 15.5024C18.004 17.9884 15.9892 20.0042 13.5021 20.0042",
    stroke: "#006487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5031 15.3353V13.6836",
    stroke: "#006487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5019 17.1582C13.4569 17.1582 13.4199 17.1952 13.4209 17.2402C13.4209 17.2852 13.4579 17.3222 13.5029 17.3222C13.5479 17.3222 13.5839 17.2852 13.5839 17.2402C13.5839 17.1952 13.5479 17.1582 13.5019 17.1582",
    stroke: "#006487",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueReportBlue);
export default __webpack_public_path__ + "static/media/issue_report_blue.6e055ae39dbaba3b0935395e22419ffd.svg";
export { ForwardRef as ReactComponent };